import {
    Card,
    CardHeader,
    Button,
    Grid2
} from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';

export const PlaceholderCard = ({
    title,
    subtitle,
    mode
}) => {
    return (
        <Card variant="outlined" sx={{ backgroundColor: 'background.default' }} data-testid="custom-editor-card">
            <Grid2 display='flex' justifyContent='space-between' paddingTop='0.5rem' sx={{ backgroundColor: mode === 'dark' ? '#34343E' : '#F3F3F4' }} data-testid="placeholder-card-custom-editor-header">
                <CardHeader title={title} titleTypographyProps={{ fontSize: '20px', color: 'text.primary' }} sx={{ pb: '0.5rem' }} />

                <Grid2 display='flex' alignItems='start' gap='1rem' marginRight='1rem'>
                    <Button
                        onClick={() => { }}
                        color='secondary'
                        variant='outlined'
                        sx={{ color: mode === "dark" ? 'text.primary' : "" }}
                        data-testid="placeholder-card-print-button"
                        startIcon={<PrintIcon color="disabled" />}
                        disabled
                    >
                        PRINT
                    </Button>
                    <Button
                        color='secondary'
                        sx={{ color: mode === "dark" ? 'text.primary' : "", marginRight: '1rem' }}
                        variant='outlined'
                        onClick={() => { }}
                        data-testid="placeholder-card-add-redaction-button"
                        disabled
                    >
                        ADD REDACTION
                    </Button>
                </Grid2>
            </Grid2>

            <CardHeader
                subheader={subtitle}
                subheaderTypographyProps={{
                    color: 'text.primary',
                }}
                sx={{ padding: '0 1rem 0.5rem 1rem', backgroundColor: mode === 'dark' ? '#34343E' : '#F3F3F4' }}
            >
            </CardHeader>
        </Card>
    )
}